import React, { useEffect, useRef } from 'react';
import { initDXFViewer } from '../three-dxf-viewer/example/layer/DXF';

// const DXFViewerComponent = ({filePath}) => { //local
const DXFViewerComponent = () => { // build
  const containerRef = useRef(null);
  const isInitializedRef = useRef(false); 

  useEffect(() => {
    const loadFile = async () => {
      if (isInitializedRef.current) return; 
      // const response = await fetch(filePath); // local
      const response = await fetch(window.filePath); // build
      const blob = await response.blob();
      initDXFViewer(containerRef.current, blob);
      isInitializedRef.current = true;
    };

    if (containerRef.current) {
      loadFile();
    }
  }, []);

  return (
    <div ref={containerRef} className="viewer-container"></div>
  );
};

export default DXFViewerComponent;
